<div class="page-wrapper pt-5">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="actions-row">
                    <mat-form-field class="search" appearance="standard">
                        <mat-label class="filter-placeholder">{{'SEARCH' | translate}}</mat-label>
                        <input matInput class="filter-input" (keyup)="applyFilter($event)" #input>
                        <div class="search-icon">
                            <fa-icon [icon]="faSearch"></fa-icon>
                        </div>
                    </mat-form-field>
                    <div class="d-flex justify-content-center mb-4">
                        <mat-button-toggle-group #toggleGroup1="matButtonToggleGroup" (change)="tabChange(toggleGroup1.value)" name="fontStyle" aria-label="Requests" [value]="tab">
                            <mat-button-toggle value="pending">{{'INCIDENT.PENDING' | translate}}</mat-button-toggle>
                            <mat-button-toggle value="history">{{'INCIDENT.HISTORY' | translate}}</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                </div>
                <div class="contents-table mat-elevation-z4">
                    <!-- Pending Table -->
                    <table mat-table matSort [dataSource]="dataSource$ | async" class="w-100" *ngIf="tab == 'pending'">
                        <caption>Incident info</caption>
                        <!-- incidentId Column -->
                        <ng-container matColumnDef="incidentId">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header="incidentId" sortActionDescription="Sort by Id Incident"> {{'INCIDENT_INFO.INCIDENT_ID' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.incidentId}} </td>
                        </ng-container>

                        <!-- submittedAt Column -->
                        <ng-container matColumnDef="submittedAt">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header="submittedAt" sortActionDescription="Sort by submittedAt"> {{'INCIDENT_INFO.SUBMISSION' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.submittedAt}} </td>
                        </ng-container>

                        <!-- oggetto Column -->
                        <ng-container matColumnDef="oggetto">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header sortActionDescription="Sort by oggetto"> {{'INCIDENT_INFO.OBJECT' | translate}} </th>
                            <td class="nv-text-ellipsis-pending" mat-cell *matCellDef="let element"> {{element.oggetto}} </td>
                        </ng-container>

                        <!-- note Column -->
                        <ng-container matColumnDef="note">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header sortActionDescription="Sort by note"> {{'INCIDENT_INFO.NOTE' | translate}} </th>
                            <td class="nv-text-ellipsis-pending" mat-cell *matCellDef="let element"> {{element.note}} </td>
                        </ng-container>

                        <!-- Details Column -->
                        <ng-container matColumnDef="details">
                            <th mat-header-cell class="text-center user-select-none font-15" *matHeaderCellDef>
                                {{'INCIDENT_INFO.DETAILS' | translate}} </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <fa-icon (click)="infoModal(element)" class="cursor-pointer info-btn" [icon]="faCircleInfo"></fa-icon>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsPending; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsPending;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{'NO_RESULT' | translate}}</td>
                        </tr>
                    </table>
                    <!-- History Table -->
                    <table mat-table matSort [dataSource]="dataSource$ | async" class="w-100" *ngIf="tab == 'history'">
                        <caption>Incident info</caption>
                        <!-- incidentId Column -->
                        <ng-container matColumnDef="incidentId">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header="incidentId" sortActionDescription="Sort by Id Incident"> {{'INCIDENT_INFO.INCIDENT_ID' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.incidentId}} </td>
                        </ng-container>

                        <!-- submittedAt Column -->
                        <ng-container matColumnDef="submittedAt">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header="submittedAt" sortActionDescription="Sort by submittedAt"> {{'INCIDENT_INFO.SUBMISSION' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.submittedAt}} </td>
                        </ng-container>

                        <!-- resolvedAt Column -->
                        <ng-container matColumnDef="resolvedAt">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header sortActionDescription="Sort by resolvedAt"> {{'INCIDENT_INFO.RESOLVED_AT' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.resolvedAt}} </td>
                        </ng-container>

                        <!-- oggetto Column -->
                        <ng-container matColumnDef="oggetto">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header sortActionDescription="Sort by oggetto"> {{'INCIDENT_INFO.OBJECT' | translate}} </th>
                            <td mat-cell class="nv-text-ellipsis-history" *matCellDef="let element"> {{element.oggetto}} </td>
                        </ng-container>

                        <!-- note Column -->
                        <ng-container matColumnDef="note">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header sortActionDescription="Sort by note"> {{'INCIDENT_INFO.NOTE' | translate}} </th>
                            <td mat-cell class="nv-text-ellipsis-history" *matCellDef="let element"> {{element.note}} </td>
                        </ng-container>

                        <!-- noteChiusura Column -->
                        <ng-container matColumnDef="noteChiusura">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header sortActionDescription="Sort by noteChiusura"> {{'INCIDENT_INFO.CLOSING_NOTE' | translate}} </th>
                            <td mat-cell class="nv-text-ellipsis-history" *matCellDef="let element"> {{element.noteChiusura}} </td>
                        </ng-container>

                        <!-- Details Column -->
                        <ng-container matColumnDef="details">
                            <th mat-header-cell class="text-center user-select-none font-15" *matHeaderCellDef>
                                {{'INCIDENT_INFO.DETAILS' | translate}} </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <fa-icon (click)="infoModal(element)" class="cursor-pointer info-btn" [icon]="faCircleInfo"></fa-icon>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsHistory; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsHistory;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{'NO_RESULT' | translate}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 d-flex justify-content-center my-4">
                <button mat-flat-button class="btn-action primary new-request-btn" (click)="newIncidentModal()">{{'NEW_INCIDENT' | translate}}</button>
            </div>
        </div>
    </div>
</div>
